<template>
  <el-dialog append-to-body :title="title" :visible.sync="dialogVisible" width="520px" :close-on-click-modal="false">
    <p class="selected-count">已选 {{ selectedCount }} 个素材</p>

    <el-form ref="formRef" :model="operationForm" :rules="rules" label-width="110px">
      <el-form-item v-if="type === BATCH_ACTION.STATUS" label="目标状态" prop="recordStatus">
        <el-radio-group v-model="operationForm.recordStatus">
          <el-radio v-for="item in statusOptions" :key="item.id" :label="item.id">{{ item.name }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item v-if="type === BATCH_ACTION.LIMIT_MEDIA" label="限制使用媒体" prop="mediaIds">
        <el-select
          v-model="operationForm.mediaIds"
          multiple
          filterable
          clearable
          placeholder="选择需要限制投放的媒体"
          style="width: 320px"
        >
          <el-option v-for="item in mediaOptions" :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="loading" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>

<script setup>
import { computed, nextTick, reactive, ref, watch } from 'vue'
import { MEDIAS, MEDIAS_LIST } from '@/common/js/constants'
import { BATCH_ACTION } from '../hooks/useMediaRejections'

// eslint-disable-next-line
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: ''
  },
  selectedCount: {
    type: Number,
    default: 0
  },
  statusOptions: {
    type: Array,
    default: () => []
  },
  initialMediaIds: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})
// eslint-disable-next-line
const emit = defineEmits(['update:visible', 'confirm'])

const formRef = ref(null)
const operationForm = reactive({
  recordStatus: undefined,
  mediaIds: []
})

const dialogVisible = computed({
  get: () => props.visible,
  set: (visible) => emit('update:visible', visible)
})
const title = computed(() => {
  if (props.type === BATCH_ACTION.STATUS) return '批量修改状态'
  return props.selectedCount > 1 ? '批量限制媒体投放' : '修改限制投放媒体'
})
const mediaOptions = MEDIAS_LIST.map((item) => ({
  ...item,
  label: item.value === MEDIAS.GDT ? '腾讯广告' : item.label
}))
const rules = {
  recordStatus: [{ required: true, message: '请选择目标状态', trigger: 'change' }]
}

watch(
  () => props.visible,
  (visible) => {
    if (!visible) return
    operationForm.recordStatus = undefined
    operationForm.mediaIds = [...props.initialMediaIds]
    nextTick(() => formRef.value?.clearValidate())
  }
)

const confirm = () => {
  formRef.value.validate((valid) => {
    if (!valid) return
    emit('confirm', {
      recordStatus: operationForm.recordStatus,
      mediaIds: [...operationForm.mediaIds]
    })
  })
}
</script>

<style lang="scss" scoped>
.selected-count {
  margin-bottom: 20px;
  color: #606266;
}
</style>
